import { type ZodTypeAny, z } from "zod";
import type InputType from "../../../../../Input/InputType";
import { JsonInputType } from "../../../../../Input/JsonInputType";
import { SideName } from "../../../../../Side/SideName";
import Rounded from "../../Rounded";

/**
 * @deprecated Use `Rounded/Corners` instead
 */
export default class Four extends Rounded {
	public static code = "plate_rectangle_rounded_corners_four";

	protected getDimensionSchema(): ZodTypeAny {
		const inputs = super.getDimensionSchema();

		return inputs.superRefine((data, context) => {
			const maximumRadius = Math.min(data.length / 2, data.width / 2);

			if (data.radius > maximumRadius) {
				context.addIssue({
					code: z.ZodIssueCode.too_big,
					type: "number",
					maximum: maximumRadius,
					inclusive: true,
					path: ["radius"],
				});
			}
		});
	}

	public calculateSideLength(side: SideName, input: InputType) {
		const length = Number(input[JsonInputType.Length]);
		const width = Number(input[JsonInputType.Width]);
		const radius = Number(input[JsonInputType.Radius]);

		if (!(Number.isNaN(length) || Number.isNaN(width) || Number.isNaN(radius))) {
			switch (side) {
				case SideName.Length1:
				case SideName.Length2:
					return length - radius * 2;
				case SideName.Width1:
				case SideName.Width2:
					return width - radius * 2;
			}
		}
		return super.calculateSideLength(side, input);
	}
}
